<div class="app-content">
  <div class="container">
    <div class="col-md-2 p-0 header hpanel sticky-plan-navbar">
      <ul class="plan-nav-menu">
        <li *ngFor="let item of planUsageList"
            class="plan-nav-item"
            [class.active]="item === selectedWidgetItem"
            (click)="onSideWidgetSelect(item)">
          <a class="plan-nav-link">
            <span class="plan-nav-text">{{item}}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="col-sm-10 ">

      <div class="hpanel gs-cardgs-card">
        <div class="panel-body pad-20-0 border-radius-top-left-right-6 plan-container">
          <div class="plan-header">
            <p>{{title}}</p>
            <p class="total-count" *ngIf="selectedWidgetItem != 'Usage'">{{totalCount | async}}</p>
          </div>
          <div class="plan-dropdown" *ngIf="selectedWidgetItem === 'Active Interactions'">
            <select #interaction [value]="selectedDropDownItem" (change)="onDropdownChange(interaction.value)" class="form-control input-sm">
              <option *ngFor="let item of basedOnUserType()" [value]="item">{{item}}</option>
            </select>
          </div>
          <div class="plan-dropdown" *ngIf="selectedWidgetItem === 'Jobs & Candidates'">
            <select id="itemName" class="form-control input-sm" #selectValue [value]="selectedDropDownItem" (change)="onDropdownChange(selectValue.value)">
              <option value="Jobs">Jobs</option>
              <option value="Candidates">Candidates</option>
            </select>
          </div>
        </div>
      </div>

      <ng-container *ngIf="loadApicall &&   (contactList|async).length==0  &&selectedWidgetItem === 'Contacts'">
        <div *ngFor="let n of [1,2,3,4,5,6,7,8]">
          <div class="col-md-3 padding-left-0 padding-right-5 padding-bottom-5">
            <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
          </div>
        </div>
      </ng-container>


          <div class="col-sm-12 pad-0" *ngIf="selectedWidgetItem === 'Contacts'">
            <div  class="contactflex col-sm-12 pad-0 p-0" style="margin-bottom: 1rem;">
              <div class="w-24 p-0" *ngFor="let item of contactList | async">
                <app-user-card [userDataInput]="item" [button]="'PRIMARY'" [standard]="true"
                  (handleEvent)="handleUserCardEvent($event)"></app-user-card>
              </div>
            </div> 
            
            <ng-container *ngIf="loadApicall && (contactList| async).length>0 ">
              <div *ngFor="let n of [1,2,3,4]">
                <div class="col-md-3 padding-left-0 padding-right-5 padding-bottom-5">
                  <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
                </div>
              </div>
            </ng-container>

          </div>
          <div class="col-sm-12 pad-0" *ngIf="selectedWidgetItem === 'Jobs'&&!loadApicall">
            <div *ngFor="let item of jobList | async">
              <app-job-card [viewSize]="'large'" [JobData]="item"></app-job-card>
            </div>
          </div>
          <div class="col-sm-12 pad-0" *ngIf="selectedWidgetItem === 'Candidates'&&!loadApicall">

            <div *ngFor="let item of candidateList | async ">
              <app-candidate-card [viewSize]="'large'" [candidateval]="item"></app-candidate-card>
            </div>

          </div>
          <div class="col-sm-12 pad-0" *ngIf="selectedWidgetItem === 'Jobs & Candidates'&&!loadApicall">

            <div *ngIf="selectedDropDownItem === 'Candidates'">
              <div *ngFor="let item of candidateList | async">
                <app-candidate-card [viewSize]="'large'" [candidateval]="item"></app-candidate-card>
              </div>
            </div>

            <div *ngIf="selectedDropDownItem === 'Jobs'">
              <div *ngFor="let item of jobList | async">
                <app-job-card [viewSize]="'large'" [JobData]="item"></app-job-card>
              </div>
            </div>

          </div>
          <div class="col-sm-12 pad-0" *ngIf="selectedWidgetItem === 'Active Interactions'&&!loadApicall">

            <div *ngIf="selectedDropDownItem === 'Candidates Invited' && candidateInviteList | async as response">
              <app-candidate-job-details class="candidateJobContent" *ngIf="response.length > 0"
                [interactionResponse]="response" [cardContent]="'INVITE'"></app-candidate-job-details>
            </div>

            <div *ngIf="selectedDropDownItem === 'Jobs Applied' && jobAppliedList | async as response">
              <app-candidate-job-details class="candidateJobContent" *ngIf="response.length > 0" [contentType]="'JA'"
                [showInteractiveButton]="true" [interactionResponse]="response"
                [cardContent]="'JA'"></app-candidate-job-details>
            </div>

            <div *ngIf="selectedDropDownItem === 'Resume Request Sent' && resumeRequestList | async as response">
              <app-candidate-job-details class="candidateJobContent" *ngIf="response.length > 0"
                [interactionResponse]="response" [cardContent]="'RESUME_SENT'"
                [showInteractiveButton]="true"></app-candidate-job-details>
            </div>

            <div *ngIf="selectedDropDownItem === 'Resume Downloaded' && resumeDownloadList | async as response">
              <div *ngIf="response?.length > 0">
                <app-candidate-card *ngFor="let item of response" class="candidateJobContent" [viewSize]="'large'"
                  [candidateval]="item" [actionMenuEnabled]="true"></app-candidate-card>
              </div>
            </div>

          </div>
          <!-- <div class="col-sm-12 mt-1" *ngIf="selectedWidgetItem === 'Resume Views'">

                          <div *ngFor="let item of resumeViewcandidateList | async">
                            <app-candidate-card [viewSize]="'large'" [candidateval]="item"></app-candidate-card>
                          </div>

                        </div> -->
          <div class="col-sm-12 pad-0" *ngIf="selectedWidgetItem === 'Usage'&&!loadApicall">

            <div class="col-sm-12 pad-0 mt-1">
              <app-price-summary></app-price-summary>
            </div>

          </div>

    

      <app-common-skeleton   *ngIf=" loadApicall && selectedWidgetItem != 'Contacts'" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
        <!-- ends here  -->
        <div *ngIf="getResponseDataLength() === 0&&!loadApicall">
          <div class="col-sm-12 pad-0 pl-1 noData" *ngIf="selectedWidgetItem === 'Contacts'  && dataLoaded">
            <div class="fs-1r">No connections found!</div>
          </div>
          <div class="col-sm-12 pad-0 pl-1 noData" *ngIf="selectedWidgetItem === 'Active Interactions' && dataLoaded">

            <div class="fs-1r" *ngIf="selectedDropDownItem === 'Candidates Invited'">
              No candidate invites found.
            </div>

            <div class="fs-1r" *ngIf="selectedDropDownItem === 'Jobs Applied'">
              No job applieds found.
            </div>

            <div class="fs-1r" *ngIf="selectedDropDownItem === 'Resume Request Sent'">
              No resume requests found.
            </div>

            <div class="fs-1r" *ngIf="selectedDropDownItem === 'Resume Downloaded'">
              No resume downloads found.
            </div>

          </div>
          <div class="col-sm-12 pad-0 pl-1 noData" *ngIf="selectedWidgetItem === 'Jobs' && dataLoaded">
            <div class="fs-1r">No jobs found!</div>
          </div>
          <div class="col-sm-12 pad-0 pl-1 noData" *ngIf="selectedWidgetItem === 'Candidates' && dataLoaded">
            <div class="fs-1r">No candidates found!</div>
          </div>
          <div class="col-sm-12 pad-0 pl-1 noData" *ngIf="selectedWidgetItem === 'Jobs & Candidates'">
            <div class="fs-1r" *ngIf="selectedDropDownItem === 'Candidates' && dataLoaded ">No
              candidates found!</div>
            <div class="fs-1r" *ngIf="selectedDropDownItem === 'Jobs' && dataLoaded && (jobList| async)?.length === 0 ">
              No jobs found!</div>
          </div>
          <!-- <div class="col-sm-12 pad-0 pl-1 noData"
                  *ngIf="selectedWidgetItem === 'Resume Views' && dataLoaded && getResponseDataLength() === 0">
                  <div class="fs-1r">No Resume Views Found</div>
                </div> -->
        </div>


        <div style="margin-top: 5rem; margin-bottom: 1rem;" class="col-sm-12 pad-0 pl-1 end" *ngIf="getDataScrollEnd() && getResponseDataLength() > 0">
          <div class="col-sm-12">
            <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
            <ng-icon name="tablerCircleCheck"></ng-icon>

          </div>
          <div class="col-sm-12">
            <p class="biase">You've reached the bottom of the page</p>
          </div>
        </div>
    </div>
  </div>
</div>
<div infiniteScroll [infiniteScrollDistance]="1" [scrollWindow]="true"
        [infiniteScrollThrottle]="1500" (scrolled)="onScrollDown()">
